import { captureException } from '@sentry/browser';

/**
 * Decode Base64 data and handle UTF-8 encoding.
 */
export default function base64Decoder(encodedData) {
  try {
    const binaryString = window.atob(encodedData);

    // convert binary string to UTF-8
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // decode UTF-8
    const decodedContent = new TextDecoder().decode(bytes);

    if (!decodedContent) {
      return '';
    }

    return decodedContent;
  } catch (e) {
    // shouldn't happen unless json parsing or b64 decoding non b64 input
    captureException(e);
    return '';
  }
}
